/*
 * Common rules
 */

/* Long level numbers */
pnx-level-select pnx-button.pnx-level-long::part(btn) {
	font-size: 0.6em;
}


/*
 * Shrink selector
 */

pnx-level-select pnx-button {
	min-height: fit-content;
	font-family: var(--font-family);
	font-size: 0.9em;
}

pnx-level-select pnx-button.pnx-level-minimal::part(btn) {
	padding: 2px 5px;
}


/*
 * Expanded selector
 */

/* Selected level */
pnx-level-select pnx-button .pnx-level-active {
	background-color: var(--widget-bg-active);
	border-radius: 13px;
	color: var(--widget-font-active);
	height: 26px;
	line-height: 26px;
	width: 26px;
}

/* Shrink button */
pnx-level-select pnx-button.pnx-level-shrink::part(btn) {
	border-top: 1px solid #cfcfcf !important;
}

/* Long list of levels scrolling */
pnx-level-select .pnx-level-scroller {
	overflow-y: auto;
	overflow-x: hidden;
	max-height: 150px;
	scroll-behavior: smooth;
}
